import React, { Component } from "react";
import { OwDeleteEditActions } from "../OwDeleteEditActions/OwDeleteEditActions";
import { OwAcceptCancelActions } from "../OwAcceptCancelActions/OwAcceptCancelActions";

type Props = {
    className?: string;
    editMode: boolean;
    cancelEditFn: () => void;
    saveEditFn: () => void;
    toggleEditFn: () => void;
    deleteEditClassName?: string;
    acceptCancelClassName?: string;
};

const OwEditModeToggle = (props: Props) => {
    return (
        <div className={"OwEditModeToggle " + props.className}>
            {props.editMode ? null : (
                <div className={props.deleteEditClassName}>
                    <OwDeleteEditActions
                        isEditMode={props.editMode}
                        onTrashClickFn={() => {}}
                        onEditClickFn={props.toggleEditFn}
                        hideTrash={true}
                    />
                </div>
            )}

            {props.editMode ? (
                <div className={props.acceptCancelClassName}>
                    <OwAcceptCancelActions
                        onAcceptClickFn={props.saveEditFn}
                        onCancelClickFn={props.cancelEditFn}
                        isEditMode={!props.editMode}
                    />
                </div>
            ) : null}
        </div>
    );
};

export default OwEditModeToggle;
